import React from "react";

const Logo = (props) => {
  return (
    <div className="logo">
        <div className={
          'sj_logo' +
          `${props.sjclass ? " " + props.sjclass : ""}` +
          `${props.animate ? " " + props.animate : ""}`
        }>
            <span>SJ Logo</span>
        </div>
        <div className={
          'playlive_logo' +
          `${props.plclass ? " " + props.plclass : ""}` +
          `${props.animate ? " " + props.animate : ""}`
        }>
        <span>Play Live logo</span>
      </div>
    </div>
  );
}

export default Logo;
